import { SxProps, Theme } from '@mui/material';
import dayjs from 'dayjs';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';

interface PrintTimeColumnProps {
  ticket: Ticket;
  sx?: SxProps<Theme>;
}

export default function PrintTimeColumn({ ticket, sx }: PrintTimeColumnProps) {
  const serviceDate = ticket.serviceDate || ticket.ocrServiceDate;

  return (
    <FlexColumn sx={sx}>
      {serviceDate && (
        <OverflowAwareText>{dayjs(serviceDate).tz().format('hh:mm A')}</OverflowAwareText>
      )}
    </FlexColumn>
  );
}
